import Common from 'src/app/common/common';
import { NavItem } from './nav-item/nav-item';
import { NavService } from '../../../services/nav.service';
import { hasRole } from '../sidebar/nav-utils';
import { RolesManageService } from 'src/app/services/roles-manage.service';


export function getNavItems(): NavItem[] {
  const role = Common.userLogin()?.role;
  const roles = Common.rolesManage();

  function hasRole(...allowed: string[]) {
    return allowed.includes(role);
  }

  return [
    {
      navCap: 'Home',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles() ||
          Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
          ? true
          : false,
    },
    {
      displayName: 'Dashboard',
      iconName: 'layout-grid-add',
      route: '/dashboard',
      bgcolor: 'primary',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles() ||
          Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator

          ? true
          : false,
    },

    {
      navCap: 'Master',
      show:
        RolesManageService.adminRoles() || RolesManageService.clientRoles()
          ? true
          : false,
    },
    {
      displayName: 'Master',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        RolesManageService.adminRoles() || RolesManageService.clientRoles()
          ? true
          : false,
      children: [
        {
          displayName: 'Commodity Type',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/commoditytype',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Crop/Commodity',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/commodity',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Variety',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/variety',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Class of Seed',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/classSeed',
          show:
            Common.userLogin()?.role === Common.rolesManage().admin ||
            Common.userLogin()?.role === Common.rolesManage().client ||
            Common.viewerUser([
              Common.rolesManage().adminview,
              Common.rolesManage().clientview,
            ]),
        },
        {
          displayName: 'Year',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/year',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Season',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/season',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Bag',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/master/bag',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },

      ],
    },

    {
      navCap: 'Register',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles()
          ? true
          : false,
    },
    {
      displayName: 'Register',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles()
          ? true
          : false,

      children: [
        {
          displayName: 'Client',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/client',
          show: RolesManageService.adminRoles() ? true : false,
        },
        {
          displayName: 'Center',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/center',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Godown',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/godown',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Farmer',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/farmer',
          show:
            RolesManageService.adminRoles() ||
              RolesManageService.clientRoles() ||
              RolesManageService.centerRoles()
              ? true
              : false,
        },
        {
          displayName: 'Procesing Plant',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/processingplant',
          show:
              RolesManageService.centerRoles()
              ? true
              : false,
        },
        {
          displayName: 'Committee Member',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/committeemember',
          show:
              RolesManageService.centerRoles()
              ? true
              : false,
        },
      ],
    },

    // {
    //   navCap: 'Allotments',
    //   show:
    //     Common.userLogin()?.role === Common.rolesManage().admin ||
    //     Common.userLogin()?.role === Common.rolesManage().client,
    // },
    {
      displayName: 'Allotment',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles()
          ? true
          : false,

      children: [
        {
          displayName: 'Target Allotment',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/allotments/target',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles()
              ? true
              : false,
        },
        {
          displayName: 'Select Farmer',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/allotments/selectfarmers',
          show: RolesManageService.centerRoles() ? true : false,
        },
        {
          displayName: 'Agri-Input Distribution',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/allotments/Agri-Input Distribution',
          show: (RolesManageService.adminRoles() || RolesManageService.clientRoles() || RolesManageService.centerRoles()) ? true : false,
          // show: (RolesManageService.centerRoles()) ? true : false,
        },

        // {
        //   displayName: 'Select Farmer',
        //   iconName: 'point',
        //   bgcolor: 'tranparent',
        //   external: false,
        //   chip: false,
        //   route: '/allotments/selectFarmer',
        //   show:
        //     Common.userLogin()?.role === Common.rolesManage().admin ||
        //     Common.userLogin()?.role === Common.rolesManage().client,
        // },
        // {
        //   displayName: 'Selected Farmer',
        //   iconName: 'point',
        //   bgcolor: 'tranparent',
        //   external: false,
        //   chip: false,
        //   route: '/allotments/selectedFarmer',
        //   show:
        //     Common.userLogin()?.role === Common.rolesManage().admin ||
        //     Common.userLogin()?.role === Common.rolesManage().client,
        // },
      ],
    },
    {
      navCap: 'Inspection',
      show:
        Common.userLogin()?.role === Common.rolesManage().admin ||
        Common.userLogin()?.role === Common.rolesManage().center ||
        Common.userLogin()?.role === Common.rolesManage().client ||
        Common.viewerUser([
          Common.rolesManage().centerview,
          Common.rolesManage().adminview,
          Common.rolesManage().clientview,
        ]),
    },
    {
      displayName: 'Inspection',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        Common.userLogin()?.role === Common.rolesManage().admin ||
        Common.userLogin()?.role === Common.rolesManage().center ||
        Common.userLogin()?.role === Common.rolesManage().client ||
        Common.viewerUser([
          Common.rolesManage().centerview,
          Common.rolesManage().adminview,
          Common.rolesManage().clientview,
        ]),

      children: [
        {
          displayName: 'Agreement',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/inspection/agreement',
          show:
            Common.userLogin()?.role === Common.rolesManage().admin ||
            Common.userLogin()?.role === Common.rolesManage().client ||
            Common.userLogin()?.role === Common.rolesManage().adminview ||
            Common.userLogin()?.role === Common.rolesManage().center ||
            Common.viewerUser([
              Common.rolesManage().centerview,
              Common.rolesManage().adminview,
              Common.rolesManage().clientview,
            ]),
        },
        {
          displayName: 'Inspection',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/inspection/agreement/inspection',
          show:
            Common.userLogin()?.role === Common.rolesManage().admin ||
            Common.userLogin()?.role === Common.rolesManage().client ||
            Common.userLogin()?.role === Common.rolesManage().adminview ||
            Common.userLogin()?.role === Common.rolesManage().center ||
            Common.viewerUser([
              Common.rolesManage().centerview,
              Common.rolesManage().adminview,
              Common.rolesManage().clientview,
            ]),
        },
      ],
    },




    {
      navCap: 'Management',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles()
          ? true
          : false,
    },
    {
      displayName: 'User Management',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        RolesManageService.adminRoles() ||
          RolesManageService.clientRoles() ||
          RolesManageService.centerRoles()
          ? true
          : false,

      children: [
        {
          displayName: 'User',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/user',
          show:
            RolesManageService.adminRoles() ||
              RolesManageService.clientRoles(2) ||
              RolesManageService.centerRoles()
              ? true
              : false,
        },
        {
          displayName: 'Assayer',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/register/assayer',
          show:
            RolesManageService.adminRoles() || RolesManageService.clientRoles(2)
              ? true
              : false,
        },
      ],
    },

    {
      navCap: 'Seed',
      show:  
            Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
    },

    {
      displayName: 'Intake & Sampling',
      iconName: 'user-plus',
      bgcolor: 'primary',
      chip: true,
      route: '',
      show:
        Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator,
      children: [
        {
          displayName: 'Dispatched Seed',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/seed/intake-sampling/dispatched-seed',
          show: Common.userLogin()?.role === Common.rolesManage().admin ||
            Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
        },
        {
          displayName: 'Received (Intake) Seed',
          iconName: 'point',
          bgcolor: 'tranparent',
          external: false,
          chip: false,
          route: '/seed/intake-sampling/received-seed',
          show: Common.userLogin()?.role === Common.rolesManage().admin ||
            Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
        },
        // {
        //   displayName: 'Sampling Seed',
        //   iconName: 'point',
        //   bgcolor: 'tranparent',
        //   external: false,
        //   chip: false,
        //   route: '/seed/processing-report',
        //   show: Common.userLogin()?.role === Common.rolesManage().admin ||
        //     Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
        // },
      ],
    },
    // {
    //   displayName: 'Seed',
    //   iconName: 'user-plus',
    //   bgcolor: 'primary',
    //   chip: true,
    //   route: '',
    //   show:
    //     Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator,
    //   children: [
    //     // {
    //     //   displayName: 'Unprocessed Seed',
    //     //   iconName: 'point',
    //     //   bgcolor: 'tranparent',
    //     //   external: false,
    //     //   chip: false,
    //     //   route: '/seed/unprocessedSeed',
    //     //   show:
    //     //     Common.userLogin()?.role === Common.rolesManage().admin ||
    //     //     Common.userLogin()?.role === Common.rolesManage().client,
    //     // },
    //     {
    //       displayName: 'Intake & Sampling',
    //       iconName: 'point',
    //       bgcolor: 'tranparent',
    //       external: false,
    //       chip: false,
    //       route: '/seed/intake-sampling',
    //       show: Common.userLogin()?.role === Common.rolesManage().admin ||
    //         Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
    //     },
    //     {
    //       displayName: 'Processing Report',
    //       iconName: 'point',
    //       bgcolor: 'tranparent',
    //       external: false,
    //       chip: false,
    //       route: '/seed/processing-report',
    //       show: Common.userLogin()?.role === Common.rolesManage().admin ||
    //         Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
    //     },
    //     {
    //       displayName: 'Seed Return',
    //       iconName: 'point',
    //       bgcolor: 'tranparent',
    //       external: false,
    //       chip: false,
    //       route: '/seed/seed-return',
    //       show: Common.userLogin()?.role === Common.rolesManage().admin ||
    //         Common.userLogin()?.role === Common.rolesManage().seedprocessingoperator
    //     },
    //   ],
    // },

    // {
    //   navCap: 'User Management',
    //   show:
    //     Common.userLogin()?.role === Common.rolesManage().admin ||
    //     Common.userLogin()?.role === Common.rolesManage().client,
    // },
    // {
    //   displayName: 'User Management',
    //   iconName: 'users-plus',
    //   route: '/register/user',
    //   bgcolor: 'primary',
    //   show:
    //     Common.userLogin()?.role === Common.rolesManage().admin ||
    //     Common.userLogin()?.role === Common.rolesManage().center,
    // },

    // {
    //   navCap: 'Ui Components',
    // },
    // {
    //   displayName: 'Badge',
    //   iconName: 'archive',
    //   route: '/ui-components/badge',
    //   bgcolor: 'warning',
    // },
    // {
    //   displayName: 'Chips',
    //   iconName: 'info-circle',
    //   route: '/ui-components/chips',
    //   bgcolor: 'success',
    // },
    // {
    //   displayName: 'Lists',
    //   iconName: 'list-details',
    //   route: '/ui-components/lists',
    //   bgcolor: 'error',
    // },
    // {
    //   displayName: 'Menu',
    //   iconName: 'file-text',
    //   route: '/ui-components/menu',
    //   bgcolor: 'primary',
    // },
    // {
    //   displayName: 'Tooltips',
    //   iconName: 'file-text-ai',
    //   route: '/ui-components/tooltips',
    //   bgcolor: 'secondary',
    // },
    // {
    //   displayName: 'Forms',
    //   iconName: 'clipboard-text',
    //   route: '/ui-components/forms',
    //   bgcolor: 'warning',
    // },
    // {
    //   displayName: 'Tables',
    //   iconName: 'table',
    //   route: '/ui-components/tables',
    //   bgcolor: 'success',
    // },

    // {
    //   navCap: 'Extra',
    // },
    // {
    //   displayName: 'Icons',
    //   iconName: 'mood-smile',
    //   route: '/extra/icons',
    //   bgcolor: 'error',
    // },
    // {
    //   displayName: 'Sample Page',
    //   iconName: 'brand-dribbble',
    //   route: '/extra/sample-page',
    //   bgcolor: 'primary',
    // },
  ];
}
